import type { ChecklistDefinition, ChecklistItem } from "./types";

const CREATOR_ITEMS: ChecklistItem[] = [
  {
    id: "welcome",
    labelKey: "onboarding.checklist.items.welcome.label",
    descriptionKey: "onboarding.checklist.items.welcome.description",
  },
  {
    id: "create-course",
    labelKey: "onboarding.checklist.items.createCourse.label",
    descriptionKey: "onboarding.checklist.items.createCourse.description",
    actionKey: "onboarding.checklist.items.createCourse.action",
    tourId: "creator-dashboard",
  },
  {
    id: "create-module",
    labelKey: "onboarding.checklist.items.createModule.label",
    descriptionKey: "onboarding.checklist.items.createModule.description",
    actionKey: "onboarding.checklist.items.createModule.action",
    tourId: "course-modules",
  },
  {
    id: "customize-module",
    labelKey: "onboarding.checklist.items.customizeModule.label",
    descriptionKey: "onboarding.checklist.items.customizeModule.description",
    actionKey: "onboarding.checklist.items.customizeModule.action",
    tourId: "graph-flow-intro",
  },
  {
    id: "explore-scene-interior",
    labelKey: "onboarding.checklist.items.exploreSceneInterior.label",
    descriptionKey: "onboarding.checklist.items.exploreSceneInterior.description",
    actionKey: "onboarding.checklist.items.exploreSceneInterior.action",
    tourId: "scene-interior-intro",
  },
  {
    id: "request-publication",
    labelKey: "onboarding.checklist.items.requestPublication.label",
    descriptionKey: "onboarding.checklist.items.requestPublication.description",
    actionKey: "onboarding.checklist.items.requestPublication.action",
    tourId: "publication",
  },
  {
    id: "invite-teammate",
    labelKey: "onboarding.checklist.items.inviteTeammate.label",
    descriptionKey: "onboarding.checklist.items.inviteTeammate.description",
    actionKey: "onboarding.checklist.items.inviteTeammate.action",
    tourId: "team-management",
  },
  {
    id: "discover-stats",
    labelKey: "onboarding.checklist.items.discoverStats.label",
    descriptionKey: "onboarding.checklist.items.discoverStats.description",
    actionKey: "onboarding.checklist.items.discoverStats.action",
    tourId: "creator-stats",
  },
];

const MANAGE_ORGANIZATION_ITEM: ChecklistItem = {
  id: "manage-organization",
  labelKey: "onboarding.checklist.items.manageOrganization.label",
  descriptionKey: "onboarding.checklist.items.manageOrganization.description",
  actionKey: "onboarding.checklist.items.manageOrganization.action",
  tourId: "admin-team",
};

const ADMIN_ITEMS: ChecklistItem[] = CREATOR_ITEMS.flatMap((item) =>
  item.id === "invite-teammate" ? [MANAGE_ORGANIZATION_ITEM, item] : [item],
);

export const CHECKLISTS: ChecklistDefinition[] = [
  {
    audience: "creator",
    titleKey: "onboarding.checklist.creator.title",
    completedKey: "onboarding.checklist.creator.completed",
    items: CREATOR_ITEMS,
  },
  {
    audience: "admin",
    titleKey: "onboarding.checklist.admin.title",
    completedKey: "onboarding.checklist.admin.completed",
    items: ADMIN_ITEMS,
  },
  {
    audience: "enduser",
    titleKey: "onboarding.checklist.enduser.title",
    completedKey: "onboarding.checklist.enduser.completed",
    items: [
      {
        id: "welcome",
        labelKey: "onboarding.checklist.items.welcomeEnduser.label",
        descriptionKey: "onboarding.checklist.items.welcomeEnduser.description",
      },
      {
        id: "take-stats-tour",
        labelKey: "onboarding.checklist.items.takeStatsTour.label",
        descriptionKey: "onboarding.checklist.items.takeStatsTour.description",
        tourId: "enduser-stats",
      },
      {
        id: "open-course",
        labelKey: "onboarding.checklist.items.openCourse.label",
        descriptionKey: "onboarding.checklist.items.openCourse.description",
        actionKey: "onboarding.checklist.items.openCourse.action",
        route: "/courses",
      },
      {
        id: "install-on-device",
        labelKey: "onboarding.checklist.items.installOnDevice.label",
        descriptionKey: "onboarding.checklist.items.installOnDevice.description",
        actionKey: "onboarding.checklist.items.installOnDevice.action",
        route: "/stats/parcours",
      },
      {
        id: "view-session",
        labelKey: "onboarding.checklist.items.viewSession.label",
        descriptionKey: "onboarding.checklist.items.viewSession.description",
        actionKey: "onboarding.checklist.items.viewSession.action",
        route: "/stats/parcours",
      },
    ],
  },
];
